// extracted by mini-css-extract-plugin
module.exports = {"el":"index-module--el--33amM","container":"index-module--container--Pz4H2","projects":"index-module--projects--gXlDO"};